<template>
    <select
        :value="value"
        @input="onChange"
        class="form-control"
    >
        <option>OK</option>
        <option>Fail</option>
        <option>N/A</option>
    </select>
</template>

<script>
export default {
    props: {
        value: {
            default: '',
        },
    },
    methods: {
        onChange (event) {
            this.$emit('input', event.target.value);
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/parts/ChecksSelectComponent.vue